import { Theme } from '@mui/material/styles';

// Все цвета исключительно через theme.palette — ни одного хардкодного hex.
// Благодаря этому компоненты корректно реагируют на смену activeTheme.
const components: any = (theme: Theme) => {
  const isLight = theme.palette.mode === 'light';

  return {
    // ─── Global ──────────────────────────────────────────────────────────────
    MuiCssBaseline: {
      styleOverrides: {
        '*': { boxSizing: 'border-box' },
        html: { height: '100%', width: '100%' },
        a: { textDecoration: 'none' },
        body: {
          height: '100%',
          margin: 0,
          padding: 0,
          backgroundColor: theme.palette.background.default,
        },
        '#root': { height: '100%' },
        "*[dir='rtl'] .buyNowImg": { transform: 'scaleX(-1)' },
        '.border-none': { border: '0px', td: { border: '0px' } },
        '.btn-xs': {
          minWidth: '30px !important',
          width: '30px',
          height: '30px',
          borderRadius: '6px !important',
          padding: '0px !important',
        },
        '.hover-text-primary:hover .text-hover': { color: theme.palette.primary.main },
        '.hoverCard:hover': { scale: '1.01', transition: '0.15s ease-in' },
        '.signup-bg': { position: 'absolute', top: 0, right: 0, height: '100%' },
        '.MuiCardHeader-action': { alignSelf: 'center !important' },
        '.emoji-picker-react .emoji-scroll-wrapper': { overflowX: 'hidden' },
        '.scrollbar-container': { borderRight: '0 !important' },
        '.theme-timeline .MuiTimelineOppositeContent-root': { minWidth: '90px' },
        '.MuiAlert-root .MuiAlert-icon': { color: 'inherit!important' },
        '.MuiTimelineConnector-root': { width: '1px !important' },
        ' .simplebar-scrollbar:before': {
          background: `${theme.palette.grey[300]} !important`,
        },
        '@keyframes gradient': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
        '@keyframes slide': {
          '0%': { transform: 'translate3d(0, 0, 0)' },
          '100%': { transform: 'translate3d(-2086px, 0, 0)' },
        },
      },
    },

    // ─── Paper ───────────────────────────────────────────────────────────────
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        },
        elevation1: {
          boxShadow: isLight
            ? `0px 2px 16px 0px ${theme.palette.primary.main}18`
            : '0px 2px 16px 0px rgba(0,0,0,0.35)',
        },
      },
    },

    // ─── Card ────────────────────────────────────────────────────────────────
    MuiCard: {
      styleOverrides: {
        root: {
          width: '100%',
          padding: '20px',
          backgroundImage: 'none',
          // backgroundColor: theme.palette.background.paper,
          backgroundColor: '#fff',
          border: `1.5px solid ${theme.palette.divider}`,
          borderRadius: '16px',
          boxShadow: isLight
            ? `0px 2px 16px 0px ${theme.palette.primary.main}14`
            : '0px 2px 16px 0px rgba(0,0,0,0.35)',
          transition: 'box-shadow 0.2s, border-color 0.2s',
          '&:hover': {
            borderColor: theme.palette.primary.light,
            boxShadow: isLight
              ? `0px 6px 28px 0px ${theme.palette.primary.main}22`
              : '0px 6px 28px 0px rgba(0,0,0,0.5)',
          },
        },
      },
    },

    MuiCardHeader: {
      styleOverrides: {
        root: { padding: '16px 20px 8px' },
        title: {
          fontSize: '1.05rem',
          fontWeight: 700,
          color: theme.palette.text.primary,
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: { padding: '8px 20px 20px' },
      },
    },

    // ─── Buttons ─────────────────────────────────────────────────────────────
    MuiButtonGroup: {
      styleOverrides: { root: { boxShadow: 'none' } },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          borderRadius: '10px',
          fontWeight: 600,
          fontSize: '0.95rem',
          transition: 'background 0.18s, box-shadow 0.18s',
          '&:hover': { boxShadow: 'none' },
        },
        contained: {
          '&:hover': {
            boxShadow: `0 4px 18px ${theme.palette.primary.main}45`,
          },
        },
        text: { padding: '6px 16px' },
        textPrimary: {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.dark,
          '&:hover': { backgroundColor: theme.palette.primary.main, color: '#fff' },
        },
        textSecondary: {
          backgroundColor: theme.palette.secondary.light,
          color: theme.palette.secondary.dark,
          '&:hover': { backgroundColor: theme.palette.secondary.main, color: '#fff' },
        },
        textSuccess: {
          backgroundColor: theme.palette.success.light,
          '&:hover': { backgroundColor: theme.palette.success.main, color: '#fff' },
        },
        textError: {
          backgroundColor: theme.palette.error.light,
          '&:hover': { backgroundColor: theme.palette.error.main, color: '#fff' },
        },
        textInfo: {
          backgroundColor: theme.palette.info.light,
          '&:hover': { backgroundColor: theme.palette.info.main, color: '#fff' },
        },
        textWarning: {
          backgroundColor: theme.palette.warning.light,
          '&:hover': { backgroundColor: theme.palette.warning.main, color: '#fff' },
        },
        outlinedPrimary: {
          borderColor: theme.palette.primary.main,
          '&:hover': { backgroundColor: theme.palette.primary.main, color: '#fff' },
        },
        outlinedSecondary: {
          '&:hover': { backgroundColor: theme.palette.secondary.main, color: '#fff' },
        },
        outlinedError: {
          '&:hover': { backgroundColor: theme.palette.error.main, color: '#fff' },
        },
        outlinedSuccess: {
          '&:hover': { backgroundColor: theme.palette.success.main, color: '#fff' },
        },
        outlinedInfo: {
          '&:hover': { backgroundColor: theme.palette.info.main, color: '#fff' },
        },
        outlinedWarning: {
          '&:hover': { backgroundColor: theme.palette.warning.main, color: '#fff' },
        },
      },
    },

    MuiFab: {
      styleOverrides: {
        root: { boxShadow: 'none' },
        sizeSmall: { width: 30, height: 30, minHeight: 30 },
      },
    },

    // ─── Inputs ──────────────────────────────────────────────────────────────
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          minHeight: '48px',
          borderRadius: '10px',
          // action.hover задаётся в каждой теме — зелёный для GREEN, синий для BLUE и т.д.
          backgroundColor: theme.palette.action.hover,
          transition: 'background 0.15s, box-shadow 0.15s',

          '& input': {
            zIndex: 1,
            fontSize: '0.975rem',
            fontWeight: 500,
            fontStyle: 'normal',
            color: theme.palette.text.primary,
            '&::placeholder': {
              color: theme.palette.text.secondary,
              opacity: 0.55,
            },
          },

          '& button': { zIndex: 2 },

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.divider,
            borderWidth: '1.5px',
            background: 'transparent',
          },

          '&:hover': {
            backgroundColor: theme.palette.primary.light,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
          },

          '&.Mui-focused': {
            backgroundColor: theme.palette.action.hover,
            boxShadow: `0 0 0 3px ${theme.palette.primary.main}28`,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
              borderWidth: '2px',
            },
          },

          '&.Mui-error': {
            backgroundColor: theme.palette.error.light,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.error.main,
              borderWidth: '1.5px',
            },
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${theme.palette.error.main}28`,
            },
          },

          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            opacity: 0.6,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
            },
          },

          '& .MuiInputAdornment-root': {
            color: theme.palette.primary.main,
          },
        },
        input: {
          padding: '12px 14px',
          fontSize: '0.975rem',
        },
        inputSizeSmall: {
          padding: '8px 12px',
          fontSize: '0.875rem',
        },
      },
    },

    MuiTextField: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            fontSize: '0.95rem',
            fontWeight: 500,
            color: theme.palette.text.secondary,
          },
          '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.8)',
            color: theme.palette.primary.main,
          },
          '& .MuiFormHelperText-root': {
            fontSize: '0.8rem',
            marginLeft: 0,
            marginRight: 0,
            marginTop: '4px',
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.95rem',
          fontWeight: 500,
          color: theme.palette.text.secondary,
          '&.Mui-focused': { color: theme.palette.primary.main },
          '&.Mui-error': { color: theme.palette.error.main },
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: { fontSize: '0.8rem', marginLeft: 0, marginTop: '4px' },
      },
    },

    // ─── Select / Dropdown ───────────────────────────────────────────────────
    MuiSelect: {
      styleOverrides: {
        root: { borderRadius: '10px' },
        select: {
          fontSize: '0.975rem',
          fontWeight: 500,
          color: theme.palette.text.primary,
          minHeight: '24px',
          padding: '12px 14px',
          '&:focus': { backgroundColor: 'transparent' },
        },
        icon: {
          color: theme.palette.primary.main,
          transition: 'transform 0.2s',
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '0.925rem',
          fontWeight: 500,
          padding: '9px 14px',
          borderRadius: '8px',
          margin: '2px 5px',
          color: theme.palette.text.primary,
          transition: 'background 0.13s',
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.dark,
          },
          '&.Mui-selected': {
            backgroundColor: `${theme.palette.primary.main}1A`,
            color: theme.palette.primary.dark,
            fontWeight: 700,
            '&:hover': {
              backgroundColor: `${theme.palette.primary.main}2E`,
            },
          },
          '&.Mui-focusVisible': {
            backgroundColor: theme.palette.primary.light,
          },
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          border: `1.5px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: isLight
            ? `0px 8px 32px ${theme.palette.primary.main}22`
            : '0px 8px 32px rgba(0,0,0,0.45)',
          padding: '4px 0',
          marginTop: '4px',
        },
        list: { padding: '4px' },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          border: `1.5px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: isLight
            ? `0px 8px 32px ${theme.palette.primary.main}22`
            : '0px 8px 32px rgba(0,0,0,0.45)',
          marginTop: '4px',
        },
        option: {
          fontSize: '0.925rem',
          fontWeight: 500,
          padding: '9px 14px',
          borderRadius: '8px',
          margin: '2px 5px',
          '&[aria-selected="true"]': {
            backgroundColor: `${theme.palette.primary.main}1A`,
            color: theme.palette.primary.dark,
            fontWeight: 700,
          },
          '&:hover': { backgroundColor: theme.palette.primary.light },
        },
        listbox: { padding: '4px' },
        tag: {
          borderRadius: '6px',
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.dark,
          fontWeight: 600,
        },
        clearIndicator: {
          color: theme.palette.text.secondary,
          '&:hover': { color: theme.palette.error.main },
        },
        popupIndicator: { color: theme.palette.primary.main },
      },
    },

    // ─── Checkbox / Radio / Switch ───────────────────────────────────────────
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: theme.palette.divider,
          '&.Mui-checked': { color: theme.palette.primary.main },
          '&:hover': { backgroundColor: `${theme.palette.primary.main}12` },
        },
      },
    },

    MuiRadio: {
      styleOverrides: {
        root: {
          color: theme.palette.divider,
          '&.Mui-checked': { color: theme.palette.primary.main },
          '&:hover': { backgroundColor: `${theme.palette.primary.main}12` },
        },
      },
    },

    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: '#fff',
            '& + .MuiSwitch-track': {
              backgroundColor: theme.palette.primary.main,
              opacity: 1,
            },
          },
        },
        track: {
          borderRadius: 12,
          backgroundColor: theme.palette.divider,
          opacity: 1,
          transition: 'background-color 0.2s',
        },
      },
    },

    // ─── Table ───────────────────────────────────────────────────────────────
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          fontSize: '0.925rem',
          padding: '12px 16px',
        },
        head: {
          fontWeight: 700,
          fontSize: '0.8rem',
          color: theme.palette.text.secondary,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          backgroundColor: theme.palette.action.hover,
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: 'background 0.13s',
          '&:last-child td': { borderBottom: 0 },
          '&:hover': { backgroundColor: theme.palette.action.hover },
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        selectLabel: { fontSize: '0.9rem', color: theme.palette.text.secondary },
        displayedRows: { fontSize: '0.9rem', color: theme.palette.text.secondary },
        select: { fontSize: '0.9rem', fontWeight: 600 },
      },
    },

    // ─── Chip ────────────────────────────────────────────────────────────────
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '0.8rem',
          borderRadius: '8px',
          height: '28px',
        },
        colorPrimary: {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.dark,
        },
        colorSuccess: {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.dark,
        },
        colorError: {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
        },
        colorWarning: {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.dark,
        },
      },
    },

    // ─── Alert ───────────────────────────────────────────────────────────────
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: '12px', fontSize: '0.925rem' },
        filledSuccess: { color: '#fff' },
        filledInfo: { color: '#fff' },
        filledError: { color: '#fff' },
        filledWarning: { color: '#fff' },
        standardSuccess: {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.dark,
        },
        standardError: {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
        },
        standardWarning: {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.dark,
        },
        standardInfo: {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.dark,
        },
        outlinedSuccess: {
          borderColor: theme.palette.success.main,
          color: theme.palette.success.dark,
        },
        outlinedWarning: {
          borderColor: theme.palette.warning.main,
          color: theme.palette.warning.dark,
        },
        outlinedError: {
          borderColor: theme.palette.error.main,
          color: theme.palette.error.dark,
        },
        outlinedInfo: {
          borderColor: theme.palette.info.main,
          color: theme.palette.info.dark,
        },
      },
    },

    // ─── Misc ────────────────────────────────────────────────────────────────
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: '12px !important',
          border: `1.5px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: 'none',
          '&:before': { display: 'none' },
          '&.Mui-expanded': {
            boxShadow: isLight
              ? `0px 4px 20px ${theme.palette.primary.main}18`
              : '0px 4px 20px rgba(0,0,0,0.35)',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.primary.light,
          borderRadius: '6px',
          height: '6px',
        },
        bar: { borderRadius: '6px' },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: { borderColor: theme.palette.divider },
      },
    },

    MuiStepConnector: {
      styleOverrides: {
        line: { borderColor: theme.palette.divider },
      },
    },

    MuiTimelineConnector: {
      styleOverrides: {
        root: { width: '1px !important', backgroundColor: theme.palette.divider },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: '#fff',
          background: theme.palette.primary.dark,
          fontSize: '0.8rem',
          fontWeight: 500,
          borderRadius: '8px',
          padding: '6px 12px',
        },
        arrow: { color: theme.palette.primary.dark },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderColor: theme.palette.divider,
          backgroundImage: 'none',
          backgroundColor: theme.palette.background.paper,
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '20px',
          backgroundColor: theme.palette.background.paper,
          boxShadow: isLight
            ? `0px 20px 60px ${theme.palette.primary.main}28`
            : '0px 20px 60px rgba(0,0,0,0.55)',
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.15rem',
          fontWeight: 700,
          color: theme.palette.text.primary,
        },
      },
    },

    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          border: `1.5px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: isLight
            ? `0px 8px 32px ${theme.palette.primary.main}20`
            : '0px 8px 32px rgba(0,0,0,0.45)',
        },
      },
    },

    MuiGridItem: {
      styleOverrides: {
        root: { paddingTop: '30px', paddingLeft: '30px !important' },
      },
    },
  };
};

export default components;